// extracted by mini-css-extract-plugin
export var answer = "bF_gY";
export var arrow = "bF_9";
export var body = "bF_g";
export var category = "bF_cT";
export var contactIcons = "bF_gR";
export var current = "bF_fv";
export var fade = "bF_gV";
export var footer = "bF_dc";
export var footerText = "bF_cl";
export var icon = "bF_bz";
export var iconContainer = "bF_bP";
export var issue = "bF_gX";
export var issueContainer = "bF_gT";
export var issueText = "bF_gW";
export var issues = "bF_gS";
export var left = "bF_bG";
export var padding = "bF_dK";
export var right = "bF_bH";
export var section = "bF_b";
export var selectors = "bF_d7";
export var subtitle = "bF_ck";
export var title = "bF_f";